import Swal from "sweetalert2";
import dayjs from "dayjs";
import "dayjs/locale/es";

export const showNotificationTopEnd = (type, message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  Toast.fire({
    icon: type,
    title: message,
  });
};

export const showSuccessModal = (type, title, message) => {
  Swal.fire({
    position: "top-end",
    icon: type,
    title: title,
    text: message,
    showConfirmButton: false,
    showCloseButton: true,
    timer: 5000
  });
};

export const maskCard = (value) => {
  return (
    value
      .replace(/\D/g, "")
      .match(/.{1,4}/g)
      ?.join(" ") || ""
  );
};

export const maskDate = (date) => {
  return dayjs(date).format("DD/MM/YYYY HH:mm");
};

export const valueDate = (date) => {
  return dayjs(date);
  //return dayjs(date).format("DD/MM/YYYY HH:mm");
};

export const formatDay = (dateISO) => {
  if (!dateISO) return "";
  const date = new Date(dateISO);
  const options = { day: '2-digit', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('es-MX', options);
}

export const selectFirstPlace = (awards) => {
  if (!awards) return "";
  return awards?.find(award => award.place === "1ER LUGAR")?.award;
}

export const formatTicketNumber = (ticketNumber, ticketAmount) => {
  if (!ticketNumber || !ticketAmount) return "";
  return ticketNumber.toString().padStart(ticketAmount.toString().length, "0");
}

export const maskDateForTickets = (date) => {
  return dayjs(date).format("DD MMM YY HH:mm [HRS]");
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(value);
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";

  const digits = phoneNumber.toString().replace(/\D/g, "");
  return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
};

export const formatWhatsMessageDate = (dateString) => {
  return dayjs(dateString)
    .locale('es')
    .format("D [de] MMMM [de] YYYY [a las] HH:mm [hrs]");
};
